const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    apiOffer: process.env.REACT_APP_OFFER_ENDPOINT,
    apiFlight: process.env.REACT_APP_FLIGHT_ENDPOINT,
    apiHotelInfo: process.env.REACT_APP_HOTELINFO_ENDPOINT,
    isAxiosMock: process.env.REACT_APP_IS_AXIOS_MOCK === true || process.env.REACT_APP_IS_AXIOS_MOCK === 'true'
}

export default config
